
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IApiCategory } from "@pazion/pazion-catalog/src/models/category";
import { IProduct } from "@pazion/pazion-catalog/src/models/product";
import { IOrderLine } from '@pazion/pazion-catalog/src/models/order';

@Component({
  filters: {
    str_limit: function (value: any, size: any) {
      if (!value) return '';

      value = value.toString();
      value = value.replace("Divina.One", "");
      value = value.replace("BAO-MED", "");

      if (value.length <= size) {
        return value;
      }
      return value.substr(0, size) + '...';
    }
  }
})
export default class QuickMenu extends Vue {
  @Prop({ default: false }) isLoading!: boolean;
  @Prop({ default: [] }) categoriesProducts!: IApiCategory[];
  @Prop() orderDetailsData: any;
  @Prop() selectedLine: IOrderLine | number | null;
  hidden: boolean = false;
  @Prop({
    default: () => {
    }
  }) handleOnClickQuickMenuProductButton: ((product: IProduct) => {}) | undefined;

  public fastQuantity: number = 0;

  public quickFastQuantityItems = [
    '2','3','4','5','6','7','8','9','10','12','14','16','18','20','24','36','48'
  ]

  onChangeFastQuantity(quantity: number) {
    this.$emit('onChangeFastQuantity', quantity);
    this.fastQuantity = 0;
  }
}//


